let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3thAq")).then(() => parcelRequire('fY7ig'));